import { VForm } from 'vuetify/components';

export type FormValidationErrors = Awaited<
  ReturnType<InstanceType<typeof VForm>['validate']>
>['errors'];

export function scrollToFirstError(errors: FormValidationErrors): void {
  if (errors.length === 0) return;
  const el = document.getElementById(String(errors[0].id));
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.focus({ preventScroll: true });
}
